import React from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons';

const SmsButtonGroup = ({ addPhoneInput, referUsers }) => (
  <div className="invite__btn-container">
    <button className="invite__add-btn" onClick={addPhoneInput}>
      + Add another
    </button>
    <button className="invite__send-btn" onClick={referUsers}>
      <FontAwesomeIcon icon={faPaperPlane} className="invite__plane-icon" />
      Send
    </button>
  </div>
);

export default SmsButtonGroup;



// WEBPACK FOOTER //
// ./src/components/Referral/SmsButtonGroup.js